import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

// action creators
import { tooltipHide } from '../../../actions/tooltipActions';

// components
import { Button } from '../_form';
import Modal from '../_Modal';
import { reduxForm, Field, reset, getFormValues, change } from 'redux-form/immutable';
import { sendMessage } from '../../../actions/tradeOffersActions';
import { appointmentCurrentRepFetch } from '../../../actions/appointmentActions';
import moment from 'moment';
import { convertDateToMonthDayYear, convertTime } from '../../../lib/formatDate';

const FORM_NAME = 'tradeRequest';

class TradeRequestModal extends React.Component {
    _handleCloseModal = () => {
      const { hideModal, id, resetForm } = this.props;

      resetForm();
      hideModal(id);
    };

    _handleFormSubmit = (e) => {
      const { id, messageSend, formValues, requestedAppointmentId } = this.props;

      e.preventDefault();
      if (!this._validate()) {
        return;
      }
      const params = {
        id,
        requested_appointment_id: requestedAppointmentId,
        offered_appointment_id: formValues.get('offeredAppointment'),
        message: formValues.get('message')
      };

      messageSend(params);
    };
    currentRepAppointmentsFetch() {
      const { fetchCurrentRepAppointments, rep, officeId } = this.props;

      const params = {
        office_id: officeId,
        'start_date':  moment().add('days', 1).format('YYYY-MM-DD'),
        rep_id: rep.get('id'),
        status:    ['booked', 'confirmed']
      };

      fetchCurrentRepAppointments(params);
    }

    _renderOfferedAppointmentOption() {
      const { currentRepAppointments, officeId } = this.props;

      if (!currentRepAppointments) {
        return null;
      }

      return (
        currentRepAppointments.valueSeq().map((currentRepAppointment) => (
          <option key={ currentRepAppointment.get('id') } value={ currentRepAppointment.get('id') }>
            {convertDateToMonthDayYear(currentRepAppointment.get('scheduledOn'))}{' '}
            {convertTime(currentRepAppointment.get('from'))}
            {!officeId && ` - ${currentRepAppointment.getIn(['office', 'name'])}`}
          </option>
        )
        ));
    }

    _validate = () => {
      const { formChange, formValues = Immutable.Map() } = this.props;
      const offeredAppointment    = formValues.get('offeredAppointment');

      if (!offeredAppointment) {
        formChange('hasError', true);
        return false;
      }
      formChange('hasError', false);
      return true;
    };

    componentDidMount() {
      const { changeFormData, rep } = this.props;

      this.currentRepAppointmentsFetch();
      changeFormData('toEmail', rep.get('email'));
    }

    _renderError() {
      const { formValues } = this.props;
      const hasError = formValues.get('hasError');
      let component;

      if (hasError) {
        component = <i className='fa fa-exclamation-circle schedule__period__error' />;
      }

      return component;
    }

    render() {
      const { id, requestedAppointmentScheduledOn, isLoading } = this.props;

      return (
        <Modal className={ 'modal__trade-request' }  id={ id }>
          <div className='modal__header'>
              Trade request
          </div>
          <form onSubmit={ this._handleFormSubmit }>
            <div>
              <div className='trade-modal__content'>
                <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                      Requested Appointment:
                </div>
                <span className={ 'trade-modal__requested-appt' }>
                  {convertDateToMonthDayYear(requestedAppointmentScheduledOn)} {requestedAppointmentScheduledOn.format('H:mm A')}
                </span>
                <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                       Offered Appointment:
                </div>
                <div className={ 'trade-modal__offered-appointment' }>
                  <Field className={ 'trade-modal__select' } component='select'
                    name='offeredAppointment'>
                    <option disabled value=''>Select offered appointment</option>
                    {this._renderOfferedAppointmentOption()}
                  </Field>
                  {this._renderError()}
                </div>
                <div className='rep-apts-index__book-modal__column rep-apts-index__book-modal__column--left'>
                    Message:
                </div>
                <Field className={ 'premium__text-area' } component={ 'textarea' } name='message' />
              </div>
            </div>
            <div className='modal__actions'>
              <Button className='form__button form__button--red rep-apts-index__book-modal__button'
                disabled={ isLoading }
                onClick={ this._handleCloseModal } type='button'>
                  Cancel
              </Button>
              <Button className='form__button form__button--green rep-apts-index__book-modal__button' loading={ isLoading } type='submit'>
                    Send request
              </Button>
            </div>
          </form>
        </Modal>
      );
    }
}

TradeRequestModal.propTypes = {
  changeFormData: PropTypes.func.isRequired,
  currentRepAppointments: PropTypes.instanceOf(Immutable.OrderedMap).isRequired,
  fetchCurrentRepAppointments: PropTypes.func.isRequired,
  formChange: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Immutable.Map).isRequired,
  hideModal: PropTypes.func.isRequired,
  id: PropTypes.string,
  isLoading: PropTypes.bool,
  messageSend: PropTypes.func.isRequired,
  officeId: PropTypes.string,
  rep: PropTypes.instanceOf(Immutable.Map),
  requestedAppointmentId: PropTypes.string.isRequired,
  requestedAppointmentScheduledOn: PropTypes.instanceOf(moment).isRequired,
  resetForm: PropTypes.func.isRequired

};

const mapStateToProps = (state) => {
  return {
    formValues:  getFormValues(FORM_NAME)(state) || Immutable.Map(),
    initialValues: {
      hasError: false
    },
    currentRepAppointments: state.getIn(['currentRepAppointments', 'data'], Immutable.OrderedMap()),
    isLoading: state.getIn(['tradeOffers', 'loading'])
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideModal: (id) => dispatch(tooltipHide({ id: id })),
    changeFormData: (state, value) => dispatch(change(FORM_NAME, state, value)),
    resetForm: () => dispatch(reset(FORM_NAME)),
    formChange: (param, value) => dispatch(change(FORM_NAME, param, value)),
    messageSend: (values) => dispatch(sendMessage(values)),
    fetchCurrentRepAppointments: (params) => {
      dispatch(appointmentCurrentRepFetch(params));
    }
  };
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
      { form: FORM_NAME }
    )(TradeRequestModal)
  )
);



// WEBPACK FOOTER //
// ./app/components/shared/modal/TradeRequestModal.jsx